export const I18n = {
    'en': {
        "": "",
        "ACCEPT": "Accept",
        "ACCEPTED": "Accepted",
        "ACTION": "Action",
        "ACTIVE": "Active",
        "ACTIVE_TT": "Active TT",
        "ADD": "Add",
        "ADD_ALL": "Add all",
        "ADD_APP": "Add app",
        "ADD_ATTRIBUTE": "Add attribute",
        "ADD_CAMPANY": "Add campany",
        "ADD_COMPANY": "Add company",
        "ADD_EDIT_ATTRIBUTE": "Add / Edit attribute",
        "ADD_EDIT_USER": "Add / Edit user",
        "ADD_ORGANISATION": "Add organisation",
        "ADD_PACKAGE": "Add package",
        "ADD_POINT": "Add point",
        "ADD_USER": "Add user",
        "ADDRESS": "Address",
        "ADMIN": "Admin",
        "ALL": "All",
        "ALL_VIEW": "All views",
        "ANDROID_VERSION": "Android version",
        "APK": "APK",
        "APK_ATTRIBUTES": "Apk attributes",
        "APK_UPLOAD": "APK upload",
        "APP": "App",
        "APP_ATTRIBUTES": "Apps attributes",
        "APP_MANAGER": "App manager",
        "APP_NAME": "App name",
        "APPLICATION": "Application",
        "APPLICATION_UPDATES": "Application updates",
        "APPS": "Apps",
        "APPS_ONLY": "Apps only",
        "APPS_READY_TO_UPDATE": "apps ready to update",
        "ARCHITECTURE": "Architecture",
        "ARE_YOU_SURE": "A you sure ?",
        "ASC": "Ascending",
        "BLOCKED": "Blocked",
        "BY_CAMPANIES": "By campanies",
        "CAMPANIES": "Campanies",
        "CAMPANY_NAME": "Campany name",
        "CANCEL": "Cancel",
        "CANCEL_SELECTION": "Сancel selection",
        "CANCELED": "Canceled",
        "CENTRAL_OFFICE_LOCATION": "Central office location",
        "CHANGED_BY": "Changed by",
        "CHANGES": "Changes",
        "CHECK_ALL_NOTIFICATIONS": "Check all notifications",
        "CHOOSE": "Choose",
        "CHOOSE_ROLE": "Choose role",
        "CITY": "City",
        "CITY_IS_REQUIRED": "City is required",
        "CLEAR_FILTERS": "Clear filters",
        "CLEAR_SELECTION": "Clear selection",
        "CLIENT": "Client",
        "CLIENT_TEL": "Client tel.",
        "CLIENT_UPDATE": "Client update",
        "CLOSE": "Close",
        "COMMENTS": "Comments",
        "COMMERCIAL": "Commercial",
        "COMPANIES": "Companies",
        "COMPANIES_LIST": "Companies List",
        "COMPANY": "Company",
        "COMPANY_ATTRIBUTES": "Company Attributes",
        "COMPANY_MARKET": "Company market",
        "COMPANY_NAME": "Company name",
        "COMPANY_TYPE": "Company Type",
        "CONTACTS": "Contacts",
        "CONTACT_US_TO_ACCESS_THIS": "Contact info@hankuper.com to access this functionality",
        "COUNTRY": "Country",
        "COUNTRY_IS_REQUIRED": "Country is required",
        "COUNTRY_REGISTRATION": "Country registration",
        "CREATE": "Create",
        "CREATE_COPMANY": "Create a company",
        "CREATE_NEW_VERSION": "Create new version",
        "DATE": "Date",
        "DATE_END": "Date end",
        "DATE_FROM": "From Date",
        "DATE_START": "Date start",
        "DATE_TO": "To Date",
        "DECLINED": "Declined",
        "DEFAULT_PASSWORD": "Default password",
        "DEFAULT_VALUE": "Default value",
        "DELETE": "Delete",
        "DELETE_ALL": "Delete All",
        "DELETE_SELECTED_APP_MESSAGE": "If selected app in a package, it will be delete fom this package.",
        "DESC": "Descending",
        "DESTINATION": "Destination",
        "DEVELOPER": "Developer",
        "DEVELOPER_CONTENT": "Developer Content",
        "DEVICES": "Devices",
        "DOWNLOAD": "DownLoad",
        "DOWNLOAD_CLIENT": "Download client",
        "DOWNLOAD_CSV": "Download CSV",
        "DOWNLOADS": "DownLoads",
        "DRAFT": "Draft",
        "EDIT": "Edit",
        "EDIT_DATA": "Edit data",
        "EDITABLE": "Editable",
        "EDITABLE_ITEM": "Editable item",
        "EMAIL": "Email",
        "EMAIL_IS_REQUIRED": "Email is requred",
        "EMAIL_LOGIN": "Email (Login)",
        "EMPLOYEE_TEL": "Employee tel.",
        "END_OF_REGISTRATION": "End of the registration",
        "FILE_FORMAT": "File format",
        "FILE_SIZE_IS_TOO_LARGE": "File size is too large",
        "FILE_TOOLTIP_TEXT": "/File format - csv. Fields: Email (Login), User name, Traiders Point name. Divider - comma.`/",
        "FILTER": "Filter",
        "FINISHED": "Finished",
        "FOLDER_WITH_SAME_NAME_ALREADY_EXISTS": "A folder with the same name already exists",
        "FORCE_UPDATE": "Force update",
        "GENERAL_REPORT": "General report",
        "GUEST": "Guest",
        "GUEST_MAIN_CONTENT": "Guest Main Content",
        "HIDE": "Hide",
        "HOME": "Home",
        "IMEI": "Imei",
        "INCORRECT_FORMAT": "Incorrect format",
        "INCORRECT_VERSION_FORMAT": "Incorrect version format",
        "INFO": "Info",
        "INNER_SYSTEM_USAGE": "Inner system usage",
        "INSTALL": "Install",
        "INSTALLS": "Installs",
        "KEYS": "Keys",
        "LABEL": "Label",
        "LAST_ACTIVE": "Last Active",
        "LATEST_AVAILABLE_VERSION": "Latest available version",
        "LIMIT": "Limit",
        "LINK_TO_PLAYMERKET": "Link to Play Market",
        "LOG_IN": "Log In",
        "MAIN_CONTENT": "Main Content",
        "MAKE_ACTIVE": "Make active",
        "MANAGER": "Manager",
        "MANAGER_IS_REQUIRED": "Manager is required",
        "MAPPING": "Mapping",
        "MARKET": "Market",
        "MEMBER": "Member",
        "MESSAGE": "Message",
        "MESSAGES_HISTORY": "Messages history",
        "MODEL": "Model",
        "MOVE_TO_GLOBAL_MARKET_MESSAGE": "Are you sure to move it to global market ?",
        "NAME": "Name",
        "NAME_IS_REQUIRED": "Name is required",
        "NEED_PASSWORD_CHANGE": "Should change the password",
        "NEW": "New",
        "NEW_USER": "New user",
        "NEXT": "Next",
        "NO": "No",
        "NO_MORE": "--- No selected Items ---",
        "NONE": "None",
        "NOTIFICATIONS": "Notifications",
        "NUMBERS": "Number",
        "NUMBER_OF_VIDEOS": "Number of videos",
        "OFFER": "Offer",
        "OFFERS": "Offers",
        "OR": "Or",
        "ORGANISATION": "Organisation",
        "OUTDATED": "Outdated",
        "PACKAGE": "Package",
        "PACKAGE_ATTRIBUTES": "Package attributes",
        "PACKAGE_CREATION": "Package creation",
        "PACKAGE_MANAGER": "Package manager",
        "PACKAGE_NAME": "Package name",
        "PACKAGES": "Packages",
        "PACKAGES_ONLY": "Packages only",
        "PACKAGES_WITH_APPS": "Packages with apps",
        "PASSWORD": "Password",
        "PENDING": "Pending",
        "PERMITTED_VALUES": "Permitted values",
        "PHONE": "Phone",
        "PHONE_IS_REQUIRED": "Phone number is required",
        "PHONE_NUMBER": "Phone number",
        "PREVIOUS": "Previous",
        "PROGRAM_VERSION": "Program version",
        "PROMOTION": "Promotion",
        "PROMO_VIDEO": "Promo video",
        "REDIRECTS": "Redirects",
        "REGISTRATION_SUCCESFULL_MESSAGE": "`You have successfully coped with the initial setup. Our manager will contact you soon and advise you in detail on how to work in the system and tell you about all its capabilities. Meanwhile you can read the instructions that we have prepared for you.`",
        "REPEAT_PASSWORD": "Repeat password",
        "REQUIRED": "Required",
        "RESET": "Reset",
        "RESET_FILTERS": "Reset filters",
        "RESET_PASSWORD": "Reset Password",
        "REWARD": "Reward",
        "ROLE": "Role",
        "ROLE_ALL": "Role (all)",
        "SALES": "Sales",
        "SALES_POINT": "Sales Point",
        "SALES_POINT_CITY": "Sales point city",
        "SAME_URL_ALREADY_EXISTS_IN_THIS_FOLDER": "The same url already exists in this folder",
        "SAVE": "Save",
        "SEARCH": "Search",
        "SEARCH_BY_NAME": "Search by name",
        "SELECT_COMPANY": "Select company",
        "SELECT_FILE": "Select a file",
        "SELECT_PACKAGE": "Select package",
        "SELECTED": "Selected",
        "SELECTED_APPS": "Selected apps",
        "SERIAL": "Serial",
        "SHOW": "Show",
        "SIGN_IN_TO_CLIENT": "Sign In to Client",
        "SKYPE": "Skype",
        "SKYPE_IS_REQUIRED": "Skype is required",
        "SOMETHING_WENT_WRONG": "Something went wrong",
        "SOURCE": "Source",
        "SP": "SP",
        "START": "Start",
        "START_WORKING": "Start working",
        "STATISTICS_BY_APPS": "Statistics by apps",
        "STATISTICS_BY_COMPANIES": "Statistics by companies",
        "STATISTICS_BY_COMPANY": "Statistics by company",
        "STATISTICS_BY_SALES_POINT": "Statistics by sales point",
        "STATISTICS_BY_SALES_POINTS": "Statistics by sales points",
        "STATUS": "Status",
        "STATUS_ALL": "Status (all)",
        "STEP_ONE": "Step one",
        "STEP_THREE": "Step three",
        "STEP_TWO": "Step two",
        "STOP": "Stop",
        "STOPPED": "Stopped",
        "SUBMIT": "Submit",
        "SUMM": "Summ",
        "SUPER_ADMIN": "Super admin",
        "SURE": "Are you sure ?",
        "THANKS": "Thanks",
        "THANKS_FOR_REGISTRATION": "Thanks for the registration!",
        "THIS_FIELD_CANNOT_BE_EMPTY": "This field cannot be empty",
        "THIS_VERSION_ALREADY_EXISTS": "This version already exists",
        "TIME": "Time",
        "TITLE": "Title",
        "TOTAL": "Total",
        "TRAIDER": "Trader",
        "TRAIDER_POINT": "Trader point",
        "TRAIDER_POINT_ATTRIBUTES": "Traders point attributes",
        "TRAIDER_POINTS_LIST": "Trader points list",
        "TRAIDERS_NETWORK": "Traiders network",
        "TT": "TT",
        "TYPE": "Type",
        "TYPE_IS_REQUIRED": "Type is required",
        "UPDATE": "Update",
        "UPDATE_ALL": "Update all",
        "UPDATE_COMMENTS": "Update comments",
        "UPDATED": "Updated",
        "UPDATES": "Updates",
        "UPDATES_ONLY": "Updates only",
        "UPLOAD": "Upload",
        "UPLOAD_APK": "Upload Apk",
        "UPLOAD_USER_FILE": "Upload file with users",
        "USER": "User",
        "USER_ATTRIBUTES": "User attributes",
        "USER_LIST": "User List",
        "VALUE": "Value",
        "VIEW": "View",
        "VIEW_SELECTION": "View selection",
        "VISIBILITY_FOR_COMPANIES": "Visibility for companies:",
        "WI_FI": "Wi-Fi",
        "WRITE_SOMETHING": "Write something...",
        "YES": "Yes",

        "isRTL": false
    },
    'ru': {
        "": "",
        "ACCEPT": "Принять",
        "ACCEPTED": "Одобрен",
        "ACTION": "Событие",
        "ACTIVE": "Активный",
        "ACTIVE_TT": "Активная TT",
        "ADD": "Добавить",
        "ADD_ALL": "Добавить (все)",
        "ADD_APP": "Добавить приложение",
        "ADD_ATTRIBUTE": "Добавить атрибут",
        "ADD_CAMPANY": "Добавить кампанию",
        "ADD_COMPANY": "Добавить компанию",
        "ADD_EDIT_ATTRIBUTE": "Добавить / редактировать атрибут",
        "ADD_EDIT_USER": "Добавить / редактировать пользователя",
        "ADD_ORGANISATION": "Добавить организацию",
        "ADD_PACKAGE": "Добавить пакет",
        "ADD_POINT": "Добавить торговую точку",
        "ADD_USER": "Добавить пользователя",
        "ADDRESS": "Адрес",
        "ADMIN": "Администратор",
        "ALL": "Все",
        "ALL_VIEW": "Все виды",
        "ANDROID_VERSION": "Версия андроида",
        "APK": "АПК",
        "APK_ATTRIBUTES": "Атрибуты АПК",
        "APK_UPLOAD": "Загрузка АПК",
        "APP": "Приложение",
        "APP_ATTRIBUTES": "Атрибуты приложения",
        "APP_MANAGER": "Диспетчер приложений",
        "APP_NAME": "Название Приложения",
        "APPLICATION": "Приложениe",
        "APPLICATION_UPDATES": "Обновление приложения",
        "APPS": "Приложения",
        "APPS_ONLY": "Только приложения",
        "APPS_READY_TO_UPDATE": "Готово к обновлению",
        "ARCHITECTURE": "Архитектура",
        "ARE_YOU_SURE": "Вы уверены ?",
        "ASC": "По возрастанию",
        "BLOCKED": "Заблокирован",
        "BY_CAMPANIES": "По кампаниям",
        "CAMPANIES": "Кампании",
        "CAMPANY_NAME": "Имя кампании",
        "CANCEL": "Отмена",
        "CANCEL_SELECTION": "Отменить выбор",
        "CANCELED": "Отменен",
        "CENTRAL_OFFICE_LOCATION": "Местонахождение цетрального офиса",
        "CHANGED_BY": "Изменено",
        "CHANGES": "Изменения",
        "CHECK_ALL_NOTIFICATIONS": "Просмотреть все уведомления",
        "CHOOSE": "Выбор",
        "CHOOSE_ROLE": "Выбор роли",
        "CITY": "Город",
        "CITY_IS_REQUIRED": "Поле город обязательно",
        "CLEAR_FILTERS": "Сбросить фильтры",
        "CLEAR_SELECTION": "Очистить выбор",
        "CLIENT": "Клиент",
        "CLIENT_TEL": "Тел. клиента",
        "CLIENT_UPDATE": "Обновление клиента",
        "CLOSE": "Закрыть",
        "COMMENTS": "Комментарии",
        "COMMERCIAL": "Рекламный",
        "COMPANIES": "Компании",
        "COMPANIES_LIST": "Список компаний",
        "COMPANY": "Компания",
        "COMPANY_ATTRIBUTES": "Атрибуты компании",
        "COMPANY_MARKET": "Маркет Компании",
        "COMPANY_NAME": "Организация",
        "COMPANY_TYPE": "Тип компании",
        "CONTACTS": "Контакты",
        "CONTACT_US_TO_ACCESS_THIS": "Для доступа к данному функционалу - обратитесь по адресу info@hankuper.com",
        "COUNTRY": "Страна",
        "COUNTRY_IS_REQUIRED": "Поле страна обязательно",
        "COUNTRY_REGISTRATION": "В рамках какой страны ведется деятельность",
        "CREATE": "Создать",
        "CREATE_COPMANY": "Создание компании",
        "CREATE_NEW_VERSION": "Создать новую версию",
        "DATE": "Дата",
        "DATE_END": "Дата окончания",
        "DATE_FROM": "C даты",
        "DATE_START": "Дата начала",
        "DATE_TO": "По дату",
        "DECLINED": "Отменить",
        "DEFAULT_PASSWORD": "Пароль по умолчанию",
        "DEFAULT_VALUE": "Значение по умолчанию",
        "DELETE": "Удалить",
        "DELETE_ALL": "Удалить все",
        "DELETE_SELECTED_APP_MESSAGE": "Если приложение входит в какой либо пакет, оно будет удалено из него.",
        "DESC": "По возрастанию",
        "DESTINATION": "Назначение",
        "DEVELOPER": "Разработчик",
        "DEVELOPER_CONTENT": "Страница разработчика",
        "DEVICES": "Девайсы",
        "DOWNLOAD": "Скачать",
        "DOWNLOAD_CLIENT": "Скачать клиент",
        "DOWNLOAD_CSV": "Выгрузить в CSV",
        "DOWNLOADS": "Установки",
        "DRAFT": "Драфт",
        "EDIT": "Изменить",
        "EDIT_DATA": "Изменить данные",
        "EDITABLE": "Возможность редактировать",
        "EDITABLE_ITEM": "Возможность редактирования",
        "EMAIL": "Почта",
        "EMAIL_IS_REQUIRED": "Поле email обязательно",
        "EMAIL_LOGIN": "Почта (Логин)",
        "EMPLOYEE_TEL": "Тел. сотрудника",
        "END_OF_REGISTRATION": "Завершение регистрации",
        "FILE_FORMAT": "Формат файла",
        "FILE_SIZE_IS_TOO_LARGE": "Слишком большой размер файла",
        "FILE_TOOLTIP_TEXT": "`Формат файла csv.Поля:Email (он же логин), Имя Пользователя, Наименование Торговой Точки. Разделитель - запятая.`,",
        "FILTER": "Применить фильтры",
        "FINISHED": "Закончен",
        "FOLDER_WITH_SAME_NAME_ALREADY_EXISTS": "Папка с таким именем уже существует",
        "FORCE_UPDATE": "Принудительное обновление",
        "GENERAL_REPORT": "Общий отчет",
        "GUEST": "Гость",
        "GUEST_MAIN_CONTENT": "Гостевой контент",
        "HIDE": "Скрыть",
        "HOME": "Главная",
        "IMEI": "Imei",
        "INCORRECT_FORMAT": "Неправильный формат",
        "INCORRECT_VERSION_FORMAT": "Неправильный формат версии",
        "INFO": "Информация",
        "INNER_SYSTEM_USAGE": "Используется внутри системы",
        "INSTALL": "Установка",
        "INSTALLS": "Установки",
        "KEYS": "Ключи",
        "LABEL": "Лейбл",
        "LAST_ACTIVE": "Активность",
        "LATEST_AVAILABLE_VERSION": "Последняя доступная версия",
        "LIMIT": "Лимит",
        "LINK_TO_PLAYMERKET": "Ссылка на Play Market",
        "LOG_IN": "Вход",
        "MAIN": "Главная",
        "MAIN_CONTENT": "Главный контент",
        "MAKE_ACTIVE": "Сделать активным",
        "MANAGER": "Менеджер",
        "MANAGER_IS_REQUIRED": "Поле менеджер обязательно",
        "MAPPING": "Маппинг",
        "MARKET": "Маркет",
        "MEMBER": "Cотрудник",
        "MESSAGE": "Сообщение",
        "MESSAGES_HISTORY": "История уведомлений",
        "MODEL": "Модель",
        "MOVE_TO_GLOBAL_MARKET_MESSAGE": "Вы хотите перенести в общий маркет ?",
        "NAME": "Имя",
        "NAME_IS_REQUIRED": "Поле имя обязательно",
        "NEED_PASSWORD_CHANGE": "Необходимо сменить пароль",
        "NEW": "Новый",
        "NEW_USER": "Новый пользователь",
        "NEXT": "Далее",
        "NO": "Нет",
        "NO_MORE": "--- Нет выбранных элементов ---",
        "NONE": "None",
        "NOTIFICATIONS": "Уведомления",
        "NUMBERS": "Кол-во",
        "NUMBER_OF_VIDEOS": "Кол-во видео",
        "OFFER": "Оффер",
        "OFFERS": "Офферы",
        "OR": "Или",
        "ORGANISATION": "Организация",
        "OUTDATED": "Устарел",
        "PACKAGE": "Пакет",
        "PACKAGE_ATTRIBUTES": "Атрибуты пакета",
        "PACKAGE_CREATION": "Пакетное создание",
        "PACKAGE_MANAGER": "Диспетчер пакетов",
        "PACKAGE_NAME": "Имя пакета",
        "PACKAGES": "Пакеты",
        "PACKAGES_ONLY": "Только Пакеты",
        "PACKAGES_WITH_APPS": "Пакеты с приложениями",
        "PASSWORD": "Пароль",
        "PENDING": "В ожидании",
        "PERMITTED_VALUES": "Допустимые значения",
        "PHONE": "Телефон",
        "PHONE_IS_REQUIRED": "Поле телефон обязательно",
        "PHONE_NUMBER": "Номер телефона",
        "PREVIOUS": "Назад",
        "PROGRAM_VERSION": "Версия программы",
        "PROMOTION": "Продвижение",
        "PROMO_VIDEO": "Промо видео",
        "REDIRECTS": "Переходы",
        "REGISTRATION_SUCCESFULL_MESSAGE": "`Вы успешно справились с первичной настройкой. Наш менеджер скоро свяжеться с Вами и детально проконсультирует по работе в системе и расскажет о всех ее возможностях. А пока Вы можете ознакомиться с инструкциями, которые мы приготовили для Вас.`",
        "REPEAT_PASSWORD": "Повторить пароль",
        "REQUIRED": "Обязательный к установке",
        "RESET": "Сбросить",
        "RESET_FILTERS": "Сбросить фильтры",
        "RESET_PASSWORD": "Сбросить пароль",
        "REWARD": "Вознаграждение",
        "ROLE": "Роль",
        "ROLE_ALL": "Роль (все)",
        "SALES": "Продажи",
        "SALES_POINT": "Торговая точка",
        "SALES_POINT_CITY": "Город торговой точки",
        "SAME_URL_ALREADY_EXISTS_IN_THIS_FOLDER": "Такой же url уже существует в данной папке",
        "SAVE": "Сохранить",
        "SEARCH": "Поиск",
        "SEARCH_BY_NAME": "Поиск по имени",
        "SELECT_COMPANY": "Выбор компании",
        "SELECT_FILE": "Выберите файл",
        "SELECT_PACKAGE": "Выбор пакета",
        "SELECTED": "Выбранные",
        "SELECTED_APPS": "Выбранные приложения",
        "SERIAL": "Серийный номер",
        "SHOW": "Показать",
        "SIGN_IN_TO_CLIENT": "Вход в приложение",
        "SKYPE": "Skype",
        "SKYPE_IS_REQUIRED": "Поле skype обязательно",
        "SOMETHING_WENT_WRONG": "Что-то пошло не так",
        "SOURCE": "Источник",
        "SP": "ТТ",
        "START": "Запуск",
        "START_WORKING": "Начать работу",
        "STATISTICS_BY_APPS": "Статистика по приложениям",
        "STATISTICS_BY_COMPANIES": "Cтатистика по организациям",
        "STATISTICS_BY_COMPANY": "Статистика по компании",
        "STATISTICS_BY_SALES_POINT": "Статистика по торговой точке",
        "STATISTICS_BY_SALES_POINTS": "Статистика по торговым точкам",
        "STATUS": "Статус",
        "STATUS_ALL": "Статус (все)",
        "STEP_ONE": "Шаг 1",
        "STEP_THREE": "Шаг 2",
        "STEP_TWO": "Шаг 3",
        "STOP": "Остановить",
        "STOPPED": "Остановлен",
        "SUBMIT": "Подтвердить",
        "SUMM": "Всего",
        "SUPER_ADMIN": "Супер админ",
        "SURE": "Вы уверены ?",
        "THANKS": "Спасибо",
        "THANKS_FOR_REGISTRATION": "Спасибо за регистрацию!",
        "THIS_FIELD_CANNOT_BE_EMPTY": "Это поле не может быть пустым",
        "THIS_VERSION_ALREADY_EXISTS": "Такая версия уже существует",
        "TIME": "Время",
        "TITLE": "Название",
        "TOTAL": "Всего",
        "TRAIDER": "Трейдер",
        "TRAIDER_POINT": "Торговая точка",
        "TRAIDER_POINT_ATTRIBUTES": "Атрибуты торговой точки",
        "TRAIDER_POINTS_LIST": "Список торговых точек",
        "TRAIDERS_NETWORK": "Торговая сеть",
        "TT": "TT",
        "TYPE": "Тип",
        "TYPE_IS_REQUIRED": "Поле тип обязательно",
        "UPDATE": "Обновить",
        "UPDATE_ALL": "Обновить все",
        "UPDATE_COMMENTS": "Обновить комментарии",
        "UPDATED": "Обновлен",
        "UPDATES": "Обновления",
        "UPDATES_ONLY": "Только Обновления",
        "UPLOAD": "Загрузить",
        "UPLOAD_APK": "Загрузка АПК",
        "UPLOAD_USER_FILE": "Загрузка файла пользователей",
        "USER": "Пользователь",
        "USER_ATTRIBUTES": "Атрибуты пользователя",
        "USER_LIST": "Список пользователей",
        "VALUE": "Значение",
        "VIEW": "Вид",
        "VIEW_SELECTION": "Выбор отображения",
        "VISIBILITY_FOR_COMPANIES": "Видимость для компаний",
        "WI_FI": "Wi-Fi",
        "WRITE_SOMETHING": "Напишите что-то...",
        "YES": "Да",

        "isRTL": false
    },
    'sk': {
        "": "",
        "ACCEPT": "Prijať",
        "ACCEPTED": "Schválený",
        "ACTION": "",
        "ACTIVE": "Aktívny",
        "ACTIVE_TT": "Aktívny TT",
        "ADD": "Pridať",
        "ADD_ALL": "Pridať všetko",
        "ADD_APP": "Pridať app",
        "ADD_ATTRIBUTE": "Pridať atribút",
        "ADD_CAMPANY": "",
        "ADD_COMPANY": "FIRMY - pridať",
        "ADD_EDIT_ATTRIBUTE": "Pridať / Upraviť atribút",
        "ADD_EDIT_USER": "Pridať / Upraviť užívateľa",
        "ADD_ORGANISATION": "Pridajte organizácie",
        "ADD_PACKAGE": "Pridať balíček",
        "ADD_POINT": "Pridať obchodníci poukazujú",
        "ADD_USER": "Pridať užívateľa",
        "ADDRESS": "Adresu",
        "ADMIN": "Admin",
        "ALL": "Všetko",
        "ALL_VIEW": "Všetky pohľady",
        "ANDROID_VERSION": "Android version",
        "APK": "APK",
        "APK_ATTRIBUTES": "Atribúty APK",
        "APK_UPLOAD": "nahrať súbor APK",
        "APP": "App",
        "APP_ATTRIBUTES": "Atribúty App",
        "APP_MANAGER": "Správca aplikácií",
        "APP_NAME": "Názov aplikácie",
        "APPLICATION": "Aplikácie",
        "APPLICATION_UPDATES": "Aktualizované app",
        "APPS": "Aplikácie",
        "APPS_ONLY": "",
        "APPS_READY_TO_UPDATE": "",
        "ARCHITECTURE": "Architektúra",
        "ARE_YOU_SURE": "Si si istý ?",
        "ASC": "Stúpajúca",
        "BLOCKED": "Upchatý",
        "BY_CAMPANIES": "",
        "CAMPANIES": "",
        "CAMPANY_NAME": "",
        "CANCEL": "Zrušiť",
        "CANCEL_SELECTION": "Voľba Сancel",
        "CANCELED": "",
        "CENTRAL_OFFICE_LOCATION": "Centrálna poloha office",
        "CHANGED_BY": "Zmenený",
        "CHANGES": "Zmeny",
        "CHECK_ALL_NOTIFICATIONS": "Zobraziť všetky upozornenia",
        "CHOOSE": "Vyberte",
        "CHOOSE_ROLE": "Vyberte si úlohu",
        "CITY": "Veľkomesto",
        "CITY_IS_REQUIRED": "Je potrebné City",
        "CLEAR_FILTERS": "Vymazať filtre",
        "CLEAR_SELECTION": "Čistý výber",
        "CLIENT": "Zákazník",
        "CLIENT_TEL": "Tel. č. klienta",
        "CLIENT_UPDATE": "Aktualizácia aplikácie",
        "CLOSE": "Close",
        "COMMENTS": "Komentáre",
        "COMMERCIAL": "Komerčný",
        "COMPANIES": "Companies",
        "COMPANIES_LIST": "Zoznam firiem",
        "COMPANY": "Spoločnosť",
        "COMPANY_ATTRIBUTES": "Atribúty Firemné",
        "COMPANY_MARKET": "Market Company",
        "COMPANY_NAME": "Spoločnosť",
        "COMPANY_TYPE": "Typ spoločnosti",
        "CONTACTS": "Kontakty",
        "CONTACT_US_TO_ACCESS_THIS": "Ak chcete získať prístup k tejto funkcii, kontaktujte info@hankuper.com",
        "COUNTRY": "Krajina",
        "COUNTRY_IS_REQUIRED": "Je potrebné krajiny",
        "COUNTRY_REGISTRATION": "Registrácia krajiny",
        "CREATE": "Vytvorte",
        "CREATE_COPMANY": "Založiť firmu",
        "CREATE_NEW_VERSION": "Vytvorte novú verziu",
        "DATE": "Dátum",
        "DATE_END": "",
        "DATE_FROM": "Od dátumu",
        "DATE_START": "",
        "DATE_TO": "Randiť",
        "DECLINED": "Zrušený",
        "DEFAULT_PASSWORD": "Predvolené heslo",
        "DEFAULT_VALUE": "Predvolená hodnota",
        "DELETE": "Vymazať",
        "DELETE_ALL": "Vymazať všetko",
        "DELETE_SELECTED_APP_MESSAGE": "Ak je zvolené aplikácie v balení, bude odstránenie FOM tento balík.",
        "DESC": "Klesajúci",
        "DESTINATION": "Destinácia",
        "DEVELOPER": "Vývojka",
        "DEVELOPER_CONTENT": "",
        "DEVICES": "Prístroje",
        "DOWNLOAD": "Stiahnuť",
        "DOWNLOAD_CLIENT": "Stiahnite si klienta",
        "DOWNLOAD_CSV": "",
        "DOWNLOADS": "Stiahnuťe",
        "DRAFT": "",
        "EDIT": "Upraviť",
        "EDIT_DATA": "Upraviť údaje",
        "EDITABLE": "Editovateľné",
        "EDITABLE_ITEM": "Editovateľné položka",
        "EMAIL": "E-mail",
        "EMAIL_IS_REQUIRED": "E-mail je vyžadované",
        "EMAIL_LOGIN": "Email (Login)",
        "EMPLOYEE_TEL": "Tel. č. zamestnanca",
        "END_OF_REGISTRATION": "koniec registrácie",
        "FILE_FORMAT": "Formát súboru",
        "FILE_SIZE_IS_TOO_LARGE": "Príliš veľká veľkosť súboru",
        "FILE_TOOLTIP_TEXT": "Formát súboru - csv. odbory: Email (Login užívateľské men Názov Traiders Point. Delič - čiarka.`,",
        "FILTER": "Filtrovanie",
        "FINISHED": "",
        "FOLDER_WITH_SAME_NAME_ALREADY_EXISTS": "A folder with the same name already exists",
        "FORCE_UPDATE": "Vynútená aktualizácia",
        "GENERAL_REPORT": "Všeobecná správa",
        "GUEST": "Hosť",
        "GUEST_MAIN_CONTENT": "Obsah pre hostí",
        "HIDE": "Skryť",
        "HOME": "",
        "IMEI": "Imei",
        "INCORRECT_FORMAT": "Nesprávny formát",
        "INCORRECT_VERSION_FORMAT": "Nesprávny formát verzie",
        "INFO": "Info",
        "INNER_SYSTEM_USAGE": "Vnútorné použitie systému",
        "INSTALL": "Inštalovať",
        "INSTALLS": "",
        "KEYS": "",
        "LABEL": "štítok",
        "LAST_ACTIVE": "Aktivita",
        "LATEST_AVAILABLE_VERSION": "Najnovšia dostupná verzia",
        "LIMIT": "",
        "LINK_TO_PLAYMERKET": "Odkaz na Play Market",
        "LOG_IN": "",
        "MAIN_CONTENT": "Hlavný obsah",
        "MAKE_ACTIVE": "Nastaviť ako aktívny",
        "MANAGER": "Manažér",
        "MANAGER_IS_REQUIRED": "Je potrebné manažér",
        "MAPPING": "Mapovanie",
        "MARKET": "Trhové",
        "MEMBER": "člen",
        "MESSAGE": "Správa",
        "MESSAGES_HISTORY": "História upozornení",
        "MODEL": "",
        "MOVE_TO_GLOBAL_MARKET_MESSAGE": "Naozaj chcete presunúť na globálnom trhu?",
        "NAME": "Názov",
        "NAME_IS_REQUIRED": "Meno je povinné",
        "NEED_PASSWORD_CHANGE": "Mali zmeniť heslo",
        "NEW": "Nový",
        "NEW_USER": "Nový užívateľ",
        "NEXT": "Ďalšie",
        "NO": "žiadny",
        "NO_MORE": "--- Žiadne ďalšie položky ---",
        "NONE": "None",
        "NOTIFICATIONS": "Oznámenia",
        "NUMBERS": "číslo",
        "NUMBER_OF_VIDEOS": "Počet videí",
        "OFFER": "Ponuka",
        "OFFERS": "",
        "OR": "Alebo",
        "ORGANISATION": "Organizácia",
        "OUTDATED": "Zastaraný",
        "PACKAGE": "Balíček",
        "PACKAGE_ATTRIBUTES": "Atribúty balíček",
        "PACKAGE_CREATION": "Vytvorenie balíček",
        "PACKAGE_MANAGER": "Package manager",
        "PACKAGE_NAME": "Názov balíka",
        "PACKAGES": "Balíčky",
        "PACKAGES_ONLY": "Iba balíčky",
        "PACKAGES_WITH_APPS": "Balíčky s aplikáciami",
        "PASSWORD": "Heslo",
        "PENDING": "Nevykonaného",
        "PERMITTED_VALUES": "Povolenej hodnoty",
        "PHONE": "Telefón",
        "PHONE_IS_REQUIRED": "Telefónne číslo je povinné",
        "PHONE_NUMBER": "Telefónne číslo",
        "PREVIOUS": "predchádzajúca",
        "PROGRAM_VERSION": "Program version",
        "PROMOTION": "",
        "PROMO_VIDEO": "Promo video",
        "REDIRECTS": "Prechody",
        "REGISTRATION_SUCCESFULL_MESSAGE": "`Úspešne ste zvládli počiatočného nastavenia. Náš manažér vám ozveme a poradí v detaile o tom, ako pracovať v systéme a informovať vás o všetkých svojich schopností. Medzitým si môžete prečítať pokyny, ktoré sme pre vás pripravili.`",
        "REPEAT_PASSWORD": "zopakujte heslo",
        "REQUIRED": "Povinná inštalácia",
        "RESET": "Resetu",
        "RESET_FILTERS": "Resetu filtre",
        "RESET_PASSWORD": "Obnoviť heslo",
        "REWARD": "",
        "ROLE": "úloha",
        "ROLE_ALL": "úloha (všetko)",
        "SALES": "",
        "SALES_POINT": "Sales Point",
        "SALES_POINT_CITY": "Mesto predajného miesta",
        "SAME_URL_ALREADY_EXISTS_IN_THIS_FOLDER": "The same url already exists in this folder",
        "SAVE": "Uložiť",
        "SEARCH": "Vyhľadávanie",
        "SEARCH_BY_NAME": "Vyhľadávanie podľa mena",
        "SELECT_COMPANY": "Výber spoločnosti",
        "SELECT_FILE": "Vyberte súbor",
        "SELECT_PACKAGE": "Vyberte balíček",
        "SELECTED": "Vybraný",
        "SELECTED_APPS": "Vybrané aplikácie",
        "SERIAL": "Sériový",
        "SHOW": "",
        "SIGN_IN_TO_CLIENT": "",
        "SKYPE": "Skype",
        "SKYPE_IS_REQUIRED": "Skype je vyžadované'",
        "SOMETHING_WENT_WRONG": "Niečo sa pokazilo",
        "SOURCE": "Zdroj",
        "SP": "SP",
        "START": "Začať",
        "START_WORKING": "Začať pracovať",
        "STATISTICS_BY_APPS": "Štatistiky podľa aplikácií",
        "STATISTICS_BY_COMPANIES": "Štatistiky podľa spoločnosti",
        "STATISTICS_BY_COMPANY": "Štatistiky podľa spoločnosti",
        "STATISTICS_BY_SALES_POINT": "Štatistiky podľa predajného miesta",
        "STATISTICS_BY_SALES_POINTS": "Štatistiky podľa predajných miest",
        "STATUS": "Postavenie",
        "STATUS_ALL": "Všetko",
        "STEP_ONE": "SKrok 1",
        "STEP_THREE": "Krok 2",
        "STEP_TWO": "Krok 3",
        "STOP": "",
        "STOPPED": "",
        "SUBMIT": "",
        "SUMM": "",
        "SUPER_ADMIN": "Super admin",
        "SURE": "Si si istý ?",
        "THANKS": "Vďaka",
        "THANKS_FOR_REGISTRATION": "Vďaka za registráciu!",
        "THIS_FIELD_CANNOT_BE_EMPTY": "This field cannot be empty",
        "THIS_VERSION_ALREADY_EXISTS": "Táto verzia už existuje",
        "TIME": "čas",
        "TITLE": "Nadpis",
        "TOTAL": "Sum",
        "TRAIDER": "Trader",
        "TRAIDER_POINT": "Trader bod",
        "TRAIDER_POINT_ATTRIBUTES": "Obchodníci poukazujú atribúty",
        "TRAIDER_POINTS_LIST": "Zoznam obchodník body",
        "TRAIDERS_NETWORK": "Traiders siete",
        "TT": "TT",
        "TYPE": "Typ",
        "TYPE_IS_REQUIRED": "Je požadovaný typ",
        "UPDATE": "Obnoviť",
        "UPDATE_ALL": "Obnoviť všetko",
        "UPDATE_COMMENTS": "Update comments",
        "UPDATED": "Aktualizované",
        "UPDATES": "Aktualizácia",
        "UPDATES_ONLY": "Iba aktualizácie",
        "UPLOAD": "Nahrať",
        "UPLOAD_APK": "APK nahrať",
        "UPLOAD_USER_FILE": "Nahrať súbor s používateľmi",
        "USER": "Užívateľ",
        "USER_ATTRIBUTES": "Atribúty užívateľa",
        "USER_LIST": "Zoznam užívateľov",
        "VALUE": "Hodnota",
        "VIEW": "Vyhliadka",
        "VIEW_SELECTION": "Voľba View",
        "VISIBILITY_FOR_COMPANIES": "Viditeľnosť pre firmy",
        "WI_FI": "Wi-Fi",
        "WRITE_SOMETHING": "Niečo napísať...",
        "YES": "áno",

        "isRTL": false
    }
}



// WEBPACK FOOTER //
// ./src/I18n/index.js